exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.radio label {\r\n    color: #333;\r\n    font-weight: 600;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.fa-info-circle {\r\n    color: #176CE7;\r\n}\r\n\r\n.dwt-panel:hover {\r\n    border: 2px solid #c4c4c4;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/program-select/program-select.component.css
// module id = ../../../../../src/app/component/program-select/program-select.component.css
// module chunks = main